export interface GridConfig {
  width: number;
  height: number;
  initialHeight: number;
}

export interface SandConfig {
  angleOfRepose: number;
  collapseRate: number;
  cohesion: number;
  erosionResistance: number;
  color: {
    low: string;
    high: string;
  };
}

export interface WaterConfig {
  flowSpeed: number;
  erosionRate: number;
  evaporationRate: number;
  color: {
    shallow: string;
    deep: string;
  };
}

export interface WaveConfig {
  enabled: boolean;
  baseTideLevel: number;
  tideAmplitude: number;
  tideFrequency: number;
  waveAmplitude: number;
  waveFrequency: number;
}

export interface PhysicsConfig {
  updateRate: number;
  gravity: number;
}

export interface RenderingConfig {
  targetFPS: number;
  vsync: boolean;
}

export interface SimulationConfig {
  grid: GridConfig;
  sand: SandConfig;
  water: WaterConfig;
  waves: WaveConfig;
  physics: PhysicsConfig;
  rendering: RenderingConfig;
}

export const DEFAULT_CONFIG: SimulationConfig = {
  grid: {
    width: 128,
    height: 128,
    initialHeight: 5
  },
  sand: {
    angleOfRepose: 35,
    collapseRate: 0.5,
    cohesion: 0.0,
    erosionResistance: 0.8,
    color: {
      low: '#E8D4A0',
      high: '#C4A572'
    }
  },
  water: {
    flowSpeed: 2.0,
    erosionRate: 0.1,
    evaporationRate: 0.001,
    color: {
      shallow: '#4A9EDB',
      deep: '#1E5A8E'
    }
  },
  waves: {
    enabled: true,
    baseTideLevel: 2,
    tideAmplitude: 1.5,
    tideFrequency: 0.1,
    waveAmplitude: 0.8,
    waveFrequency: 0.5
  },
  physics: {
    updateRate: 60,
    gravity: 9.8
  },
  rendering: {
    targetFPS: 60,
    vsync: true
  }
};
